/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel' <vishal@wakencode.com>, April 2020
 *
 *****************************************************************************/

export const constant = {
  SOME_ERROR_OCCURRED_IN_FETCHING_PROPERTIES:
    "Some error occurred in fetching properties",
  FETCHING_COORDINATES: "Fetching coordinates",
  FETCHING_PROPERTIES: "Fetching properties",
  PRESS_PLAY_TO_SEE_PATH: "Press play to see path",
  NO_COORDINATES_FOUND: "No coordinates found",
  SOME_ERROR_OCCURRED: "Some error occurred",
  NO_PROPERTIES_FOUND: "No properties found",
  SUCCESSFULLY_SAVED_GEOMETRIES: "Successfully saved geometries",
  SOME_ERROR_OCCURRED_IN_SAVING_GEOMETRIES:
    "Some error occurred in saving geometries",
  SAVING_GEOMETRIES: "Saving geometries",
  POPUP_WARNING: `You have not saved your recent changes. Either Cancel this popup and go back and save changes or press "Don't save" to discard changes`,
  CONTINUE: "Continue",
  DISMISS: "Dismiss",
  GEOFENCE_NOT_EXIST: "Create geofence as it doesn't exist",
  SELECT_ANY_GEOMETRY_TO_DELETE: "Select any geometry to delete",
  SELECT_ANY_PROPERTY_TO_CREATE_ONE: "Select any property to create a new one",
  I_ICON_HOVER_GEOFENCE: `If date is selected then only properties having workorder on this date will be shown. "Include Inactive" will also show properties where there is no active job`,
  I_ICON_HOVER_LIVE:
    "By default properties for Today's workOrders are shown. Use this checkbox to show all property",
  SAVE_ICON_HOVER_MSG: "Save geometry",
  DELETE_ICON_HOVER_MSG: "Delete geometry",
  SWITCH_TO: "Switch to",
  ONLINE: "online",
  OFFLINE: "offline",
  UNKNOWN: "unknown",
  STATUS: "Status",
  LAST_UPDATED: "Last Updated",
  CHECK_DETAILS: "Check details",
  SELECT_START_AND_END_TIME_TO_SEE_REPLAY_COORDINATES:
    "Select start date time and end date time to see the replay",
  START_TIME_NOT_GREATER_THAN_END_TIME:
    "Start time shouldn't be greater than end time",
  PROPERTY: "Property",
  CLEAR: "Clear",
  STARTING_POINT: "It is starting point",
  NO_MORE_PATH: "No more path to show",
  SHOW_ALL_PROPERTIES: "Show All Properties",
  INCLUDE_INACTIVE: "Include Inactive",
  END_TIME_NOT_GREATER_24HRS_FROM_START_TIME:
    "End time shouldn't be more than 24 hours from start time",
  NOT_APPLICABLE: "Not Applicable",
  CLOSE: "Close",
  VEHICLE_NAME: "Vehicle Name",
  USER_NAME: "User Name",
  START_DATE__TIME: "Start Date Time",
  DATE_SHOULD_NOT_BE_AFTER_END_DATE: "Date should not be after end date",
  END_DATE_TIME: "End Date Time",
  END_DATE_SHOULD_NOT_BE_BEFORE_START_DATE:
    "END date should not be before start date",
  SUBMIT: "Submit",
  LOCATION_TIME: "Location time",
  CONTROLS: "Controls",
  PLAY: "play",
  PAUSE: "pause",
  RESET: "reset",
  PLOT_WHOLE_PATH: "plot whole path",
  BACK_10: "back 10 sec",
  FOREWORD_10: "forward 10 sec",
  FOREWORD_30: "forward 30 sec",
  SECS_AGO: "secs ago",
  MINS_AGO: "min(s) ago",
  HRS_AGO: "hr(s) ago",
  DAYS_AGO: "day(s) ago",
  MONTHS_AGO: "month(s) ago",
  TOTAL_VEHICLES: "Total vehicles",
  TOTAL_UNPAIRED_USERS: "Total unpaired users",
  TOTAL_PAIRED_USERS: "Total paired users",
  SHOW_ALL_GEOMETRIES_INFO: "Geometries info",
  SHOW_ALL_WORKORDER_INFO: "WorkOrders info",
  ALLOW_TO_SEE_NAME_OF_PROPERTY_IN_MAP_SECTION:
    "This checkbox will allow you to see name of property in Map section",
  MULTIPLE_WORKORDERS_TEXT:
    "Multiple workOrders are present for this date. Open Property page to see details.",
  TOTAL_NO_OF_PROPERTIES: "Total no. of properties found",
  CLICK_TO_SEE_PROPERTY_IN_SERVICE_ACTIVATOR:
    "Click to see property in service activator",
  ADDRESS: "Address",
  EDIT: "Edit",
  CANCEL: "Cancel",
  DONT_SAVE: "Don't Save",
  WORK_ORDER: "Work order",
  CLICK_TO_SEE_WORKORDER_IN_SERVICE_ACTIVATOR:
    "Click to see work order in service activator",
  GO_BACK: "Go back",
  ASSIGN_TECHNICIAN: "Assign technician",
  JOB_FILTER_DESC: "Filter out the job type",
  SHOW_ALL_JOBS: "Show all jobs",
  SHOW_TECHNICIAN_JOBS: "Show technician jobs",
  SHOW_CONTRACTOR_JOBS: "Show contractor jobs",
  SHOW_UNASSIGNED_JOBS: "Show unassigned jobs",
  SERVICE_DATE: "Service date",
  OPEN_IN_NEW_TAB: "Open in new tab",
  NO_TECHNICIAN_ASSIGNED: "No technician assigned",
  NO_JOBS_AVAILABLE: "No jobs available",
  ERROR_IN_ASSIGNING_TECHNICIAN: "Error in assigning technician",
  USER_FILTER_DESC: "Filter out individual Technician/Contractor job",
  TECHNICIAN_CONTRACTOR: "Technician/Contractor",
  FILTER_TO_SHOW_ONLY_JOBS_ASSIGNED_TO_YOUR_TEAM:
    "Use this filter to show only jobs which are assigned to your team",
  NO_TECHNICIAN_CONTRACTOR_ASSIGNED: "No technician/contractor assigned",
  TECHNICIANS: "Technicians",
  CONTRACTORS: "Contractors",
  DELETE: "Delete",
  GEOFENCE_DELETE_CONFIRMATION_MSG:
    "Are you sure that you want to delete this geofence?",
  TECHNICIAN_NOT_FOUND: "Technician not found",
  INSUFFICIENT_ACCESS: "Insufficient access",
  TECHNICIAN_ASSIGNED: "Technician assigned",
  UNABLE_TO_GET_REQUIRED_PROPERTY: "Unable to get the required property",
  REQUIRED_PROPERTY_NOT_FOUND: "Required property not found",
  REFRESH: "Refresh",
  PROPERTY_URL: "properties",
  WORK_ORDER_URL: "workorders",
};



